export const calculatePercentageChange = (
  currentValue: number,
  previousValue: number,
  decimalPlaces: number = 2,
): number => {
  if (previousValue === 0) {
    return currentValue === 0 ? 0 : 100
  }

  const result = ((currentValue - previousValue) / previousValue) * 100

  return Number(result.toFixed(decimalPlaces))
}

export const calculateValuePercentageChange = (value: [number, number]): number =>
  calculatePercentageChange(value[0], value[1], 0)
